import React from "react";
import HomePageComponent from "../components/home/index";

const HomePage = () => {
  return (
    <>
      <HomePageComponent />
    </>
  );
};

export default HomePage;
